import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { PARTNERS } from "../keys";

const usePartners = () => {
  const tenant = useSelector((state) => state.auth.tenant);

  return useQuery({
    queryKey: [PARTNERS, tenant.id],
    queryFn: () => ApiService.getPartners(),
    select: (data) => JSON.parse(JSON.stringify(data.data)),
    placeholderData: {data: []},
  });
};
export default usePartners;
